require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./klamath-county-victim-and-family-justice-program.json") })
        }
      }, "path---klamath-county-victim-and-family-justice-program");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---klamath-county-victim-and-family-justice-program!./.cache/json/klamath-county-victim-and-family-justice-program.json
// module id = 918
// module chunks = 231608221292675